import {
  EnvironmentOutlined,
  MailOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Form, Input, notification } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useState } from "react";

import { images } from "../assets";
import APIService from "../services/APIService";

const Contact = () => {
  const [form] = Form.useForm();
  const [disable, setDisable] = useState(false);

  // const { value: showPassword, handleToggleValue: handleTogglePassword } =
  //   useToggleValue();

  async function contact(values) {
    const RESULT = await APIService.contact(
      values.topic,
      values.title,
      values.content,
      values.fullname,
      values.email,
      values.phone
    );
    if (RESULT) {
      notification["success"]({
        message:
          "Sphacy cám ơn bạn đã liên hệ với chúng tôi.Thông tin liên hệ bạn đã được tiếp nhận và chúng tôi liên hệ với bạn trong thời gian sớm nhất.",
        // description: 'Quay lại trang chủ để đặt đơn hàng mới'
      });
    }
  }

  const onContactFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleContact = (values) => {
    contact(values);
    setDisable(true);
    form.resetFields();
  };
  return (
    <div className="w-full">
      <h3 className="md:text-[26px] text-[#222222] text-sm font-bold not-italic md:font-bold capitalize my-[20px]">
        THÔNG TIN LIÊN HỆ
      </h3>
      <div className="flex flex-col-reverse flex-1 w-full md:flex-row gap-y-2">
        {/* <div className="shadow-lg p-5 bg-white flex flex-col flex-1 rounded-[10px] justify-start">
          <div className="flex items-center mb-3">
            <div className="w-[74px] h-[74px] p-[15px] border rounded-full border-blue-400">
              <img src={images.logo} className="w-[48px] h-[48px]" alt="" />
            </div>
            <div className="ml-[21px] w-[128px] h-[28px] ">
              <img src={images.Sphacy} alt="" />
            </div>
          </div>
          <div className="flex flex-col gap-y-[8px]  mb-3">
            <span className="text-sm font-bold text-[#222222]">
              Trụ Sở Chính:
            </span>
            <span className="text-sm font-normal text-[#222222]">
              • Tầng 3, Toà nhà An Phú, 117-119 Lý Chính Thắng, phường Võ Thị
              Sáu, quận 3, Tp. HCM
            </span>
            <span className="text-sm font-bold text-[#222222]">Chi Nhánh:</span>
            <span className="text-sm font-normal text-[#222222]">
              • B42 đường 4A phường Tân Hưng, Q.7, Tp. HCM
            </span>
            <span className="text-sm font-bold text-[#222222]">
              Văn phòng Hà Nội:
            </span>
            <span className="text-sm font-normal text-[#222222]">
              • Tầng 07, Tòa nhà Ladeco, số 266 Đội Cấn, Phường Liễu Giai, Quận
              Ba Đình, Hà Nội
            </span>
          </div>
          <div className="flex md:flex-row flex-col gap-y-2 md:gap-x-[25px] mb-2">
            <div className="flex py-2 pl-3 pr-7 border-[1px] border-solid border-[#D9D9D9] rounded items-start bg-[#F3F3F3]">
              <div className="leading-[30px] mr-4">
                <MailOutlined className="mr-2 w-[16px] h-[16px] site-form-item-icon" />
              </div>
              <div className="flex flex-col justify-center ">
                <span className="text-sm not-italic font-normal capitalize">
                  Email:
                </span>
                <span className="text-sm not-italic font-normal capitalize">
                  info@sphacy.vn
                </span>
              </div>
            </div>
            <div className="flex py-2 pl-3 pr-7 border-[1px] border-solid border-[#D9D9D9] rounded items-start bg-[#F3F3F3]">
              <div className="leading-[30px] mr-4">
                <PhoneOutlined className="mr-2 w-[16px] h-[16px] site-form-item-icon" />
              </div>
              <div className="flex flex-col justify-center ">
                <span className="text-sm not-italic font-normal capitalize">
                  Điện Thoại:
                </span>
                <span className="text-sm not-italic font-normal capitalize">
                  02836201313
                </span>
              </div>
            </div>
            <div className="flex py-2 pl-3  border-[1px] border-solid border-[#D9D9D9] rounded items-start bg-[#F3F3F3]">
              <div className="leading-[30px] mr-4">
                <UserOutlined className="mr-2 w-[16px] h-[16px] site-form-item-icon" />
              </div>
              <div className="flex flex-col justify-center ">
                <span className="text-sm not-italic font-normal capitalize">
                  Hotline:
                </span>
                <span className="text-sm not-italic font-normal capitalize">
                  1900575718-0917777711
                </span>
              </div>
            </div>
          </div>
          <div className="w-full h-full md:w-[600px] md:h-[193px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.3118078319803!2d106.68286321471858!3d10.787413492314057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3175298a24586347%3A0xc310e45015e5674d!2zVMOyYSBOaMOgIEFuIFBow7ogUGxhemE!5e0!3m2!1svi!2s!4v1668064239275!5m2!1svi!2s"
              width="100%"
              height="100%"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div> */}

        <div className="flex flex-1 flex-col shadow-lg bg-white rounded-[10px]">
          <div className="flex flex-col gap-y-[12px] p-5 ">
            <h3 className="mb-2 text-sm not-italic font-bold capitalize text-[#222222] md:mb-3 md:font-extrabold md:text-lg">
              SPHACY XIN HÂN HẠNH ĐƯỢC HỖ TRỢ QUÝ KHÁCH
            </h3>
            <p className="font-normal text-[#222222] text-xs md:text-sm">
              Quý Khách Đang Quan Tâm Về
            </p>
            <Form
              form={form}
              size="large"
              name="normal_login"
              className="contact-form"
              initialValues={{ remember: true }}
              onFinish={handleContact}
              onFinishFailed={onContactFailed}
            >
              <Form.Item
                name="topic"
                rules={[{ required: true, message: "Vui lòng nhập chủ đề" }]}
              >
                <Input
                  placeholder="Chọn chủ đề"
                  className="text-sm font-medium placeholder:italic"
                />
              </Form.Item>
              <Form.Item
                name="title"
                rules={[{ required: true, message: "Vui lòng nhập tiêu đề" }]}
              >
                <Input
                  placeholder="Tiêu đề"
                  className="text-sm font-medium placeholder:italic"
                />
              </Form.Item>
              <Form.Item
                name="content"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập nội dung",
                  },
                ]}
              >
                <Input.TextArea placeholder="Nội dung" showCount />
              </Form.Item>
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Email không đúng định dạng",
                    type: "email",
                    pattern: RegExp(
                      /^[a-z][a-z0-9_.]{5,32}@[a-z0-9]{2,}(\.[a-z0-9]{2,4}){1,2}$/gm
                    ),
                  },
                ]}
              >
                <Input
                  prefix={<MailOutlined className="mr-2 site-form-item-icon" />}
                  type="email"
                  placeholder="Email"
                  className="text-sm font-medium placeholder:italic"
                />
              </Form.Item>
              <Form.Item
                name="fullname"
                rules={[{ required: true, message: "Vui lòng nhập họ và tên" }]}
              >
                <Input
                  prefix={<UserOutlined className="mr-2 site-form-item-icon" />}
                  placeholder="Họ và tên"
                  className="text-sm font-medium placeholder:italic"
                />
              </Form.Item>
              <Form.Item
                name="phone"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập Số điện thoại đúng định dạng",
                    pattern: new RegExp(/(84|0[3|5|7|8|9])+([0-9]{8,11})\b/g),
                  },
                ]}
              >
                <Input
                  prefix={
                    <PhoneOutlined className="mr-2 site-form-item-icon" />
                  }
                  type="text"
                  placeholder="Số Điện Thoại"
                  className="text-sm font-medium placeholder:italic"
                />
              </Form.Item>
              <>
                <div className="flex justify-center text-white font-bold item-center my-[12px]">
                  <button
                    disabled={disable}
                    type="submit"
                    className={`w-[252px] h-[50px] p-2 rounded-[30px] ${
                      disable ? "bg-blue-200" : "bg-[#119AE2]"
                    } `}
                  >
                    Gửi Liên Hệ
                  </button>
                </div>
              </>
            </Form>
          </div>
        </div>
        <div className="w-4"></div>
        <div className="shadow-lg p-5 bg-white flex flex-col flex-1 rounded-[10px] justify-start">
          <div className="flex items-center mb-3">
            <div className="w-[74px] h-[74px] p-[15px] border rounded-full border-blue-400">
              <img src={images.logo} className="w-[48px] h-[48px]" alt="" />
            </div>
            <div className="ml-[21px] w-[128px] h-[28px] ">
              <img src={images.Sphacy} alt="" />
            </div>
          </div>
          <div className="flex flex-col gap-y-[8px]  mb-3">
            <span className="text-sm font-bold text-[#222222]">
              Trụ Sở Chính:
            </span>
            <span className="text-sm font-normal text-[#222222]">
              • Tầng 3, Toà nhà An Phú, 117-119 Lý Chính Thắng, phường Võ Thị
              Sáu, quận 3, Tp. HCM
            </span>
            <span className="text-sm font-bold text-[#222222]">Chi Nhánh:</span>
            <span className="text-sm font-normal text-[#222222]">
              • B42 đường 4A phường Tân Hưng, Q.7, Tp. HCM
            </span>
            <span className="text-sm font-bold text-[#222222]">
              Văn phòng Hà Nội:
            </span>
            <span className="text-sm font-normal text-[#222222]">
              • Tầng 07, Tòa nhà Ladeco, số 266 Đội Cấn, Phường Liễu Giai, Quận
              Ba Đình, Hà Nội
            </span>
          </div>
          <div className="flex md:flex-row flex-col gap-y-2 md:gap-x-[25px] mb-2">
            <div className="flex py-2 pl-3 pr-7 border-[1px] border-solid border-[#D9D9D9] rounded items-start bg-[#F3F3F3]">
              <div className="leading-[30px] mr-4">
                <MailOutlined className="mr-2 w-[16px] h-[16px] site-form-item-icon" />
              </div>
              <div className="flex flex-col justify-center ">
                <span className="text-sm not-italic font-normal capitalize">
                  Email:
                </span>
                <span className="text-sm not-italic font-normal capitalize">
                  info@sphacy.vn
                </span>
              </div>
            </div>
            <div className="flex py-2 pl-3 pr-7 border-[1px] border-solid border-[#D9D9D9] rounded items-start bg-[#F3F3F3]">
              <div className="leading-[30px] mr-4">
                <PhoneOutlined className="mr-2 w-[16px] h-[16px] site-form-item-icon" />
              </div>
              <div className="flex flex-col justify-center ">
                <span className="text-sm not-italic font-normal capitalize">
                  Điện Thoại:
                </span>
                <span className="text-sm not-italic font-normal capitalize">
                  02836201313
                </span>
              </div>
            </div>
            <div className="flex py-2 pl-3  border-[1px] border-solid border-[#D9D9D9] rounded items-start bg-[#F3F3F3]">
              <div className="leading-[30px] mr-4">
                <UserOutlined className="mr-2 w-[16px] h-[16px] site-form-item-icon" />
              </div>
              <div className="flex flex-col justify-center ">
                <span className="text-sm not-italic font-normal capitalize">
                  Hotline:
                </span>
                <span className="text-sm not-italic font-normal capitalize">
                  1900575718-0917777711
                </span>
              </div>
            </div>
          </div>
          <div className="w-full h-full md:w-[600px] md:h-[193px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.3118078319803!2d106.68286321471858!3d10.787413492314057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3175298a24586347%3A0xc310e45015e5674d!2zVMOyYSBOaMOgIEFuIFBow7ogUGxhemE!5e0!3m2!1svi!2s!4v1668064239275!5m2!1svi!2s"
              width="100%"
              height="100%"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;



var iCount = 0;
var dBalance;
var dDeposit = [];
var loop = 0;
do
{
    dBalance = dBalance + dDeposit[iCount];
    iCount = iCount + 2;
    loop = loop++;
}
while (iCount < 60);
console.log(loop)
